import type { Pagination } from '@app/pages/Warehouses/WarehouseOperations/types';

export const getRange = ({ ItemsPerPage, Total, Page }: Pagination) => {
  if (ItemsPerPage <= 0 || Total <= 0 || Page <= 0) {
    return { from: 0, to: 0 };
  }
  const from = (Page - 1) * ItemsPerPage + 1;
  const to = Math.min(Page * ItemsPerPage, Total);

  return { from, to };
};
